import { CurrentPriceMessageContent } from "Components/CurrentPriceMessage/CurrentPriceMessageContent";
import { CustomerDiscounts } from "Components/CurrentPriceMessage/CustomerDiscounts";
import { StickyWrapper } from "Components/StickyWrapper/StickyWrapper";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { CalculationPrice } from "Store/priceCalculation/priceCalculationInterfaces";
import { usePriceCalculationSelector } from "Store/priceCalculation/priceCalculationSelectors";
import { sum } from "Utils/arrayUtils";
import { getPricePerMonth, getPricePerYear } from "Utils/priceUtils";
import React, { ReactElement } from "react";

interface Props {
  selectedPrices: CalculationPrice[];
  sticky: boolean;
  productBackendName: ProductBackendName;
}

export const CurrentPriceMessageElement = ({
  selectedPrices,
  sticky,
  productBackendName,
}: Props): ReactElement => {
  const {
    priceCalculationResult: { isLoading },
  } = usePriceCalculationSelector();

  const pricePerYear = selectedPrices.map(getPricePerYear).reduce(sum, 0);
  const pricePerMonth = selectedPrices.map(getPricePerMonth).reduce(sum, 0);

  return (
    <>
      {sticky ? (
        <StickyWrapper withMarginBottom={false}>
          <CurrentPriceMessageContent
            monthlyPrice={pricePerMonth}
            yearlyPrice={pricePerYear}
            isLoading={isLoading}
          />
        </StickyWrapper>
      ) : (
        <CurrentPriceMessageContent
          monthlyPrice={pricePerMonth}
          yearlyPrice={pricePerYear}
          isLoading={isLoading}
        />
      )}
      <CustomerDiscounts
        productBackendName={productBackendName}
        prices={selectedPrices}
      />
    </>
  );
};
